module.exports = __webpack_public_path__ + "static/img/junk-icon.80bcc8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/junk-icon.png
// module id = yFVk
// module chunks = 1